import destroy from "@/views/destroy/destroy";
export default destroy;
